import React from "react";
import { DispatchProp } from "react-redux";
import { ChoiceModel } from "../../models/ChoiceModel";
import { BaseChoice, ChoiceProps } from "./BaseChoice";
import { getSettingBoolean } from "../../models/utilities/settingUtilities";
import { getRendererProps } from "../renderers/BaseRenderer";
import CheckBoxRenderer from "../renderers/v2/CheckBoxRenderer";
import ChoiceLabelRenderer from "../renderers/v2/ChoiceLabelRenderer";

interface State {
    checked: boolean;
}

export class CheckBox extends BaseChoice<{}, State> {
    constructor(props: ChoiceProps & DispatchProp) {
        super(props);
        this.state = {
            checked: props.isSelected,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: {} & ChoiceProps) {
        if (this.state.checked !== nextProps.isSelected) {
            this.setState({ checked: nextProps.isSelected });
        }
    }

    onSelect = () => {
        this.updateValue();

        this.disableAndResetHybridQuestionMapppedCell(this.props.executeUpdateForIdAfterSelection);
    };

    updateValue() {
        if (this.props.isDisabled) {
            return;
        }
        this.setState((s) => {
            const newState = { ...s };
            newState.checked = !s.checked;
            return newState;
        });
        this.setMentions(this.props.variable.name, (mentions) => {
            const isSelectedExclusive = getSettingBoolean(this.props.choice, "Exclusive");
            if (this.props.variable.choiceList !== undefined) {
                this.props.variable.choiceList
                    .filter((choice) => this.props.choice.index !== choice.index)
                    .forEach((choice) => {
                        if (isSelectedExclusive || getSettingBoolean(choice, "Exclusive")) {
                            mentions = mentions.removeValue(choice.value);
                        }
                    });
            }
            return mentions.toggle(this.props.choice.value, this.props.openEnd);
        });
    }

    renderChoice(choice: ChoiceModel) {
        return (
            <>
                <CheckBoxRenderer
                    {...getRendererProps(this.props)}
                    choice={choice}
                    ref={this.props.choiceRef}
                    id={`${choice.elementId}_INPUT`}
                    name={this.props.variable.name}
                    value={choice.value}
                    onSelect={this.onSelect}
                    checked={this.state.checked}
                    isDisabled={this.props.isDisabled}
                    variable={this.props.variable}
                />
                <ChoiceLabelRenderer
                    {...getRendererProps(this.props)}
                    choice={choice}
                    gridRendering={this.props.gridRendering}
                />
            </>
        );
    }
}
